<template>
<!-- 开票开票详情 -->
<div>
  <el-form-item label="开票类别">
    <template slot-scope="scope">
      <span v-for="item in options.issued_type"
        v-if="form.issued_type * 1 === item.value * 1">{{item.label}}</span>
    </template>
  </el-form-item>
  <el-form-item label="申请描述">
    {{form.desc}}
  </el-form-item>
  <el-form-item label="BD" v-if="isPreReceived">
    {{form.bd_name}}
  </el-form-item>
  <el-form-item label="BO审批">
    {{form.bu_name}}
  </el-form-item>
  <el-form-item label="抄送人">
    {{form.cc_name}}
  </el-form-item>
  <el-form-item label="开票备注">
    {{form.memo}}
  </el-form-item>
  <el-form-item label="客户名称/编号">
    {{form.customer_name}}/{{form.customer_number}}
  </el-form-item>
  <InvoiceApplyReceiptInfo :receiptInfo="form.receipt_info_json"/>
  <el-form-item label="账期">
    <span>{{ form.pay_condition_name }}</span>
  </el-form-item>
  <el-form-item label="发票类别"
                prop="type">
    <template slot-scope="scope">
      <span v-for="item in options.type"
            v-if="form.type === item.value">{{item.label}}</span>
    </template>
  </el-form-item>
  <el-form-item label="开票主体"
                prop="subject_name">
    <span>{{form.subject_name}}</span>
  </el-form-item>
  <el-form-item label="币种"
                prop="currency_type">
    <template slot-scope="scope">
      <span v-for="item in options.currency_type"
            v-if="form.currency_type === item.value">{{item.label}}</span>
    </template>
  </el-form-item>
  <el-form-item label="开票金额依据"
                prop="invoice_tax_type">
    <template slot-scope="scope">
        <span v-for="item in options.tax_type"
              v-if="form.invoice_tax_type === item.value">{{ item.label }}</span>
    </template>
  </el-form-item>
  <el-form-item label="发票备注"
                prop="invoice_remark">
    <span>{{ form.invoice_remark }}</span>
  </el-form-item>
</div>
</template>

<script>

import InvoiceApplyReceiptInfo from './InvoiceApplyReceiptInfo'

export default {
  components: {
    InvoiceApplyReceiptInfo,
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.invoiceApply.options,
    }),
    isPreReceived () {
      return this.form.issued_type * 1 === 2
    }
  },
  data () {
    return {}
  },
  methods: {
  },
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/InvoiceApplyInfo.vue